import { useState } from 'react';

export function useModalState(initial = false) {
    const [isOpen, setOpen] = useState(initial);
    return {
        isOpen,
        open: () => setOpen(true),
        close: () => setOpen(false),
    };
}
